import {Component, Inject, Input, OnInit, Optional, Self, ViewChild} from '@angular/core';
import {NgControl} from '@angular/forms';
import {BaseAnswerTypeComponent} from '../base-answer-type.component';
import {FileDto} from '../../../../models/file';
import {PublicFilesService} from '../../../../services/public-files.service';
import {SimpleFileUploaderComponent} from '../../../../modules/simple-file-uploader/simple-file-uploader.component';
import {ConfigsLoaderService} from '../../../../services/config-loader.service';
import {MatTableDataSource} from '@angular/material/table';
import {ComparableOperator} from '../../../../models/form';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-files-input',
  templateUrl: './files-input.component.html',
  styleUrls: ['./files-input.component.scss'],
})
export class FilesInputComponent extends BaseAnswerTypeComponent<number[]> implements OnInit {

  constructor(
    @Optional()
    @Inject(MAT_DIALOG_DATA)
    public data?: FilesInputComponent,
    @Optional()
    private dialogRef?: MatDialogRef<FilesInputComponent>,
    @Optional() @Self() ngControl?: NgControl,
    private uploadFileService?: PublicFilesService,
    private config?: ConfigsLoaderService,
  ) {
    super(ngControl);
  }
  @Input() maxLength = 200;
  @Input() placeholder = '';
  @Input() label = '';

  @Input() initialData: FileDto[];

  @Input() uploadEndpoint: string;

  @Input() allowedExtensions = '.doc,.DOC,.docx,.DOCX,.xml,.XML,.odt,.ODT,.pdf,.PDF,.rtf,.RTF,.txt,.TXT,.wpd,.WPD,.jpg,.JPG,.png,.PNG,.7z,.7Z,.rar,.RAR,.zip,.ZIP,.csv,.CSV,.bmp,.BMP,.svg,.SVG,.tif,.TIF,.tiff,.TIFF,.ods,.ODS,.xls,.XLS,.xlsm,.XLSM,.xlsx,.XLSX,.mp4,.MP4,.mp3,.MP3,.m4a,.M4A,.msg,.MSG,.ogg,.OGG,.opus,.OPUS,.pptx,.PPTX,.eml,.EML,.aac,.AAC,.gif,.GIF,.jpeg,.JPEG';
  @ViewChild('fileUploader') fileUploader: SimpleFileUploaderComponent;
  filesData: Partial<FileDto>[] = [];

  isDialog: boolean = false;
  readOnly: boolean = true;

  displayedColumns = [
    'name',
    'type',
    'size',
    'remove',
  ];
  // static defaultValue = [-1];
  matDatasource = new MatTableDataSource([]);

  AllowedOperators: {[K in ComparableOperator]: (t: number[], value: any) => boolean} = {
    [ComparableOperator.Equal]: null,
    [ComparableOperator.NotEqual]: null,
    [ComparableOperator.Contains]: null,
    [ComparableOperator.StartWith]: null,
    [ComparableOperator.EndWith]: null,
    [ComparableOperator.In]: null,
    [ComparableOperator.GreaterThan]: null,
    [ComparableOperator.GreaterThanOrEqual]: null,
    [ComparableOperator.LessThan]: null,
    [ComparableOperator.LessThanOrEqual]: null,
    [ComparableOperator.IsNullOrEmpty]: (target) => !target?.length,
    [ComparableOperator.NotIsNullOrEmpty]: (target) => !! target?.length,
    [ComparableOperator.Between]: null,
  };

  ngOnInit() {
    if (!this.uploadEndpoint) {
      this.uploadEndpoint = `File/UploadFileFormAnswerTypeAttachment`
    } else {
      this.uploadEndpoint = this.uploadEndpoint;
    }
  }


  ngAfterViewInit() {

    this.matDatasource.data = this.initialData;

    if (this.data) {
      this.isDialog = true;
      this.matDatasource.data = this.data.initialData;
      this.uploadEndpoint = this.data.uploadEndpoint;
      this.allowedExtensions = this.data.allowedExtensions;
      this.readOnly = this.data.readOnly;
      this.label = this.data.label;
    }

    this.fileUploader.rawFiles = this.matDatasource.data;

    if (this.dialogRef) {
      this.dialogRef.beforeClosed().subscribe(() => this.dialogRef.close(this.matDatasource.data));
    }

    if (!this.isDialog) {
      super.ngAfterViewInit();
    }

    this.fileUploader.changes.subscribe(files => {
      // console.log(files);
      if (!this.isDialog) {
        this.setValue(files.map(f => f.id));
      }
      
      this.matDatasource.data = [...files];
      console.log(this.matDatasource.data);
    });
  }

  onDismiss() {
    this.dialogRef.close(this.matDatasource.data);
  }


}
